import React from 'react'

import FieldUsers from "../users"
import FieldUsers_Pill from "../components/pill"

type FieldMultiselectViewProps = {
    field       : FieldUsers
    model       : any
    className?  : string
    options?    : any
    onClick?    : onClick
}

export default function FieldUsers_View(props:FieldMultiselectViewProps) {

    const value         = _.get(props.model, props.field.fieldId, null)
    const valueOptions  = props.field._getOptions(value)

    if (!valueOptions) return false

    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-default fl-ac max-w-300 fl-wrap m-t-4 m-b-4", props.className)} onClick={props.onClick}>
                {_.map(valueOptions, (option) => {
                    return <FieldUsers_Pill key         = {option.value}
                                            className   = "m-r-10 m-t-4 m-b-4"
                                            option      = {option}/>
                })}
            </div>
        </React.Fragment>
    )
}
